export class HttpTimeoutError extends Error {
  critical: boolean = false;

  constructor(public readonly meta: any) {
    super('Request timed out');
    this.name = 'HttpTimeoutError';
  }
}
